'use es6'; // Stolen from enviro. wanted to remove deps

var qaRegex = /(?:hubspot|hubteam|grader|getsignals|getsidekick|gettally|leadin|hubspotemail|customer-hub|hubspotservicehub)qa\.com|(?:hubspotstarter|hubspotfree)qa\.net|(?:growth)qa\.org/;

var isProd = function isProd() {
  return !qaRegex.test(document.location.host);
};

export default {
  isProd: isProd
};